import { Check, AlertCircle, X } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Row, Col, Button } from 'react-bootstrap'

const Notification = ({ type = 'info', text, link = '', handleClose }) => {
  const navigate = useNavigate()

  const typeStyles = {
    success: 'bg-success',
    error: 'bg-danger',
    info: 'bg-primary'
  }

  return (
    <Row
      className="position-fixed top-0 end-0 m-3"
      style={{ maxWidth: '350px', zIndex: 1050 }}
    >
      <Col className="px-0">
        <div className="d-flex align-items-center bg-dark text-white rounded overflow-hidden shadow">
          <div className={`p-3 ${typeStyles[type]}`}>
            {type === 'success' ? (
              <Check size={18} />
            ) : (
              <AlertCircle size={18} />
            )}
          </div>
          <div className="flex-grow-1 px-3 py-2">
            <span className="fw-bold" style={{ fontSize: '11px' }}>
              {text}
            </span>
          </div>
          <div className="d-flex align-items-center">
            {link && (
              <Button
                variant="link"
                className="text-white text-decoration-none px-3"
                onClick={() => navigate(link)}
              >
                View
              </Button>
            )}
            <Button
              variant="link"
              className="text-white px-3"
              onClick={handleClose}
            >
              <X size={16} />
            </Button>
          </div>
        </div>
      </Col>
    </Row>
  )
}

export default Notification
